import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import Loader from '../../components/Loader'
import { useModuleAdmins } from '../../hooks/Authentication/useModuleAdmins'
import AddModuleAdmin from './AddModuleAdmin'

export default function EditModuleAdmin() {
  const { getModuleAdmin, moduleAdmin, loading } = useModuleAdmins()
  const params = useParams()

  useEffect(() => {
    getModuleAdmin({ moduleAdminId: params.moduleAdminId })
  }, [params.moduleAdminId])

  return <> {loading ? <Loader /> : <AddModuleAdmin moduleAdmin={moduleAdmin} />} </>
}
